import { render, staticRenderFns } from "./IconPhoneOutgoingSolid.vue?vue&type=template&id=52f1dea8"
import script from "./IconPhoneOutgoingSolid.vue?vue&type=script&lang=js"
export * from "./IconPhoneOutgoingSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports